import { render } from "./AdminNews.vue?vue&type=template&id=63f1639d&scoped=true"
import script from "./AdminNews.vue?vue&type=script&lang=js"
export * from "./AdminNews.vue?vue&type=script&lang=js"

import "./AdminNews.vue?vue&type=style&index=0&id=63f1639d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f1639d"]])

export default __exports__